import axios from "axios";
import jwtDecode from "jwt-decode";
import { AUTH_ENDPOINTS, BASE } from "./constants/Endpoints";
import { processAccessTokenResponse } from "./utils/Auth";

const http = axios.create({
  baseURL: BASE,
});
axios.defaults.baseURL = BASE;

let interceptor = null;

const addInterceptor = (dispatch = null) => {
  http.interceptors.request.handlers = [];
  interceptor = http.interceptors.request.use(
    async (config) => {
      let accessToken = localStorage.getItem("accessToken");
      const refreshToken = localStorage.getItem("refreshToken");
      if (accessToken && refreshToken) {
        const decodedAccessToken = jwtDecode(accessToken);
        const decodedRefreshToken = jwtDecode(refreshToken);
        if (decodedAccessToken.exp * 1000 < Date.now()) {
          if (decodedRefreshToken.exp * 1000 < Date.now()) {
            if (dispatch) dispatch({ type: "NOT_AUTHENTICATED" });
            return Promise.reject("Refresh token expired");
          }
          try {
            const accessTokenResponse = await axios.post(
              AUTH_ENDPOINTS.TOKEN_REFRESH,
              refreshToken
            );
            processAccessTokenResponse(accessTokenResponse);
            accessToken = localStorage.getItem("accessToken");
          } catch (error) {
            if (dispatch) dispatch({ type: "NOT_AUTHENTICATED" });
            return Promise.reject(error);
          }
        }
        config.headers.Authorization = `Bearer ${accessToken}`;

        const impersonatedUserId = localStorage.getItem("impersonatedUserId");
        if (impersonatedUserId) {
          config.headers["Impersonated-User-Id"] = impersonatedUserId;
        }
      }
      return config;
    },
    (error) => {
      Promise.reject(error);
    }
  );
};

const deleteInterceptor = () => {
  if (interceptor == null) return;
  http.interceptors.request.eject(interceptor);
  interceptor = null;
};

const getAccessToken = () => {
  return localStorage.getItem("accessToken");
};

const getRefreshToken = () => {
  return localStorage.getItem("refreshToken");
};

// eslint-disable-next-line
export default {
  get: http.get,
  post: http.post,
  put: http.put,
  delete: http.delete,
  instance: http,
  createInstance: addInterceptor,
  deleteInstance: deleteInterceptor,
  getAccessToken: getAccessToken,
  getRefreshToken: getRefreshToken,
};
